import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Container,
} from "@mui/material";
import "./about.css";
import { GraduationCap, Infinity } from "lucide-react";

const benefitsData = [
  {
    title: "High Quality Courses",
    description:
      "Gain access to expertly crafted courses designed by industry professionals. Learn from comprehensive, up-to-date materials that ensure real-world application and skill  mastery",
    icon: "/newimage/about/writing.png",
  },
  {
    title: "Life Time Access",
    description:
      "Enroll once and enjoy unlimated access to your courses forever. Revisit lessons, stay updated with new content, and continue learning at your own pace without  restrictions.",
    icon: "/newimage/about/renewable.png",
  },
  {
    title: "Expert Instructors",
    description:
      "Learn from seasone professionals with years of industry experience. Our instructors brings practical insights, engaging teaching methods, and hands-on guidance to help you succeed",
    icon: "/newimage/about/brand.png",
  },
];

const BenefitsSection = () => {
  return (
    <section className="py-12">
      <div className="container mx-auto text-center px-6">
        <div className="bg-black text-white px-20 py-2 inline-block rounded-3xl text-xl font-semibold mb-6">
          Our Benefits:
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefitsData.map((benefit, index) => (
            <div
              key={index}
              className="bg-orange-500 text-white p-8 rounded-2xl shadow-lg flex flex-col items-center text-center h-75 w-full max-w-sm mx-auto "
            >
              <img
                src={benefit.icon}
                alt={benefit.title}
                className="w-20 h-20 mb-4 object-contain filter invert brightness-0 contrast-200 "
              />
              <h3 className="text-lg font-semibold mb-2 ">{benefit.title}</h3>
              <p className="text-sm px-4">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
